// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__aiLeG","loaderOuter":"PageOverlayLoader_loaderOuter__2ZQD5"};